import React, { useEffect, useState } from 'react'
import LoginMobileHeader from '../../components/header/LoginMobileHeader';
import LoginHeader from '../../components/header/LoginHeader';
import Gotop from '../../components/gotop';
import ProfileResume from '../ViewProfile/ProfileResume';
import UserResume from './UserResume';
import ViewProfile from '../ViewProfile/ViewProfile';
import NonLoginHeader from '../../components/header/NonLoginHeader';
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader';
import CRMobileHeader from '../../components/header/CRMobileHeader';
import MobileHeader from '../../components/header/MobileHeader';
import InstituteHeader from '../../components/header/InstituteHeader';
import CRHeader from '../../components/header/CRHeader';

const UserProfile = () => {
    const [isShowMobile, setShowMobile] = useState(false);

    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);

  const module =localStorage.getItem("Module")
  return (
    <>
            {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader clname="applications" handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader clname="applications" handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader clname="applications" handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRHeader clname="applications" handleMobile={handleMobile} /> :
                            <NonLoginHeader clname="applications" handleMobile={handleMobile} />}

            <div className="pt-70">


            <UserResume /> 
            <Gotop />
            </div>
            </>

  )
}

export default UserProfile